<template v-cloak>
  <v-card class="pa-3" height="100%">
    <v-sheet v-if="isLoading">
      <v-skeleton-loader
        class="mx-auto"
        max-width="300"
        type="image, divider, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line "
      />
    </v-sheet>
    <v-dialog v-model="chgimg" max-width="40%">
      <v-card>
        <v-card-title>
          <span class="headline">Change Picture</span>
        </v-card-title>
        <form enctype="multipart/form-data">
          <v-file-input
            class="pa-4"
            label="Upload image"
            filled
            prepend-icon="mdi-camera"
            accept="image/*"
            @change="imgSelected"
          ></v-file-input>

          <v-card-actions>
            <v-btn color="blue darken-1" text @click="saveImg()"
              >Update Profile Picture</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <v-container v-show="!isLoading" fluid>
      <div class="d-flex justify-center">
        <v-badge bordered bottom color="green" offset-x="35" offset-y="20">
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-avatar size="120">
                <img
                  :lazy-src="profileimg"
                  :src="profileimg"
                  alt="Profile Image"
                />
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn small @click="chgImg()"
                      ><span class="change-btn"> Change Picture</span>
                    </v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-avatar>
            </template>
          </v-hover>
        </v-badge>
      </div>

      <v-layout d-block text-center class="mt-2 mb-1">
        <h3
          class="subtitle-3"
          :class="{ 'red-text': employee.RequiresSupervision }"
        >
          {{ employee.Name }}
        </h3>

        <span v-if="employee.MedCertified">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="blue--text" v-bind="attrs" v-on="on">
                check_circle_outline
              </v-icon>
            </template>
            <span>Med Certified</span>
          </v-tooltip>
        </span>

        <span v-if="employee.FirstAid">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="red--text" v-bind="attrs" v-on="on">
                local_hospital
              </v-icon>
            </template>
            <span>First Aid Certified</span>
          </v-tooltip>
        </span>

        <span v-if="employee.CertifiedDriver">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="green--text" v-bind="attrs" v-on="on">
                local_shipping
              </v-icon>
            </template>
            <span>Certified Driver</span>
          </v-tooltip>
        </span>
      </v-layout>

      <!-- <v-btn
          depressed
          color="primary"
          block
          class="mt-2"
          :to="'/vehicleInspection/'+employeeID"
        >

          Vehicle Inspection
        </v-btn> -->
      <v-btn
        depressed
        color="primary"
        block
        class="mt-2"
        :to="'/staffCommunication/' + employeeID"
        v-if="admin"
      >
        Communication Log
      </v-btn>

      <v-divider class="mt-5"></v-divider>
      <v-card-text>Phone Number</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ employee.PhoneNumber }}
        </div>
      </v-card-title>
      <v-card-text>Hire Date</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ hireDate }}
        </div>
      </v-card-title>
      <v-card-text>Birth Date</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ birthDate }}
        </div>
      </v-card-title>
      <v-card-text>Anniversary</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ anniversaryDate }}
        </div>
      </v-card-title>
      <v-card-text>Email</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ employee.Email }}
        </div>
      </v-card-title>
      <v-card-text>Address</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ employee.Address }}, {{ employee.City }}, {{ employee.State }},
          {{ employee.Zip }}
        </div>
      </v-card-title>
      <!-- <v-card-text>Employment Status</v-card-text>
      <v-card-title class="mt-n2 mb-2">
        <div class="subtitle-1">
          {{ employee.Status }}
        </div>
      </v-card-title> -->
      <!-- <v-card-text>Program</v-card-text>
      <span
        class="mt-n2 mb-2 ml-1 subtitle-1"
        v-for="program in employee.Program"
        :key="program._id">

          {{ program }},

      </span> -->
      <v-expansion-panels class="ma-n2 pa-n3 pt-3" flat>
        <v-expansion-panel>
          <v-expansion-panel-header> View Programs </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider></v-divider>
            <v-list>
              <v-list-item
                v-for="program in employee.Program"
                :key="program._id"
              >
                <v-list-item-content>{{ program }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapActions } from "vuex";
import usersRoles from "@/views/UsersRoles.vue";

const url = require("../client_config/config").url;

export default {
  data: () => ({
    employee: [],
    chgimg: false,
    overlay: false,
    uploadImg: "",
    profileimg: "",
    employeeID: "",
    isLoading: true,
    admin: false,
    hireDate: "",
    birthDate: "",
    anniversaryDate: "",
  }),

  computed: {
    usersRoles() {
      return usersRoles;
    },
  },

  created() {
    this.employeeID = this.$route.params.employeeID;
    this.getEmployees(this.employeeID);
    const userRole = localStorage.getItem("userRole");
    if (
      userRole === "Administration" ||
      userRole === "Human Resources" ||
      userRole === "Compliance Manager" ||
      userRole === "Program Coordinator" ||
      userRole === "Client Services Manager" ||
      userRole === "Program Manager" ||
      userRole === "SuperAdministrator" ||
      userRole === "Medical Manager"
    ) {
      this.admin = true;
    } else {
      this.admin = false;
    }
  },

  methods: {
    ...mapActions({
      getStaffInfo: "staff/getStaff",
    }),

    initialize() {
      this.employee = [];
    },

    async getEmployees() {
      try {
        this.isLoading = true;
        let response = await this.getStaffInfo(this.employeeID);
        this.employee = response;
        const timestamp = Date.parse(this.employee.BirthDate);
        this.profileimg = this.employee.Image;
        this.birthDate = !isNaN(timestamp)
          ? moment(this.employee.BirthDate).format("YYYY/MM/DD")
          : "";
        this.anniversaryDate = !isNaN(Date.parse(this.employee.AnniversaryDate))
          ? moment(this.employee.AnniversaryDate).format("YYYY/MM/DD")
          : "";
        this.hireDate = moment(this.employee.Date).format("MM/DD/YYYY");
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    /*
    getEmployees() {
      this.isLoading = true;
      axios.get(`${url}/employees/${this.employeeID}`).then(async (res) => {
        this.employee = res.data.employee;
        this.profileimg = this.employee.Image;
        this.hireDate = moment(this.employee.Date).format("MM/DD/YYYY")
      }).finally(() => this.isLoading = false);
    },
    */

    close() {
      this.seditInfo = false;
      this.passdialog = false;
      this.chgimg = false;
    },
    chgImg() {
      this.chgimg = true;
    },
    imgSelected(e) {
      this.uploadImg = e;
    },
    saveImg() {
      //console.log(this.uploadImg)
      const formData = new FormData();
      formData.append("profile-img", this.uploadImg);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(`${url}/employees/imguploader/${this.employeeID}`, formData, ct)
        .then((res) => {
          //this.profileimg = '/uploads/'+res.data.file.filename;
          this.close();
          this.getEmployees(this.employeeID);
          this.text =
            "The account profile picture has been updated successfully.";
          this.msg = true;
          if (res) {
            console.log();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    updateSupervisionStatus() {
      axios
        .put(`${url}/users/${this.employee._id}`, {
          RequiresSupervision: this.employee.RequiresSupervision,
        })
        .then((response) => {
          console.log("Update successful:", response.data);
        })
        .catch((error) => {
          console.error("Error updating:", error);
        });
    },
  },
};
</script>
<style scoped>
@media only screen and (max-width: 480px) {
  .v-sheet.v-card#card {
    max-height: 500px;
  }

  /*
  .v-sheet.v-card {
    display: none;
  }
  */

  .inline {
    display: inline-block;
  }
}

.change-btn {
  font-size: 8px;
}

.red-text {
  color: red;
}
</style>
